import { render } from "./UserWalletItemFilter.vue?vue&type=template&id=0cb48db9&scoped=true&ts=true"
import script from "./UserWalletItemFilter.vue?vue&type=script&lang=ts"
export * from "./UserWalletItemFilter.vue?vue&type=script&lang=ts"

import "./UserWalletItemFilter.vue?vue&type=style&index=0&id=0cb48db9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb48db9"]])

export default __exports__